module.exports = __webpack_public_path__ + "img/briefcase.8aa459ae.svg";